<template xmlns="">
  <div id="help">
    <!-- 顶部导航栏 -->
    <van-nav-bar :title="$t('title.help')" placeholder safe-area-inset-top @click-left="onClickLeft" left-arrow />

    <van-col span="22" offset="1">
      <van-col span="24">
        <van-row gutter="20">
          <van-col span="8" v-for="(item,i) in help_type" :key="i">
            <van-col span="24" :class="type_i === i ? 'help_type_active help_type' : 'help_type'" @click.native="help_type_btn(i)">  <img :src="item.group_img"/> {{ item.title }} </van-col>
          </van-col>
        </van-row>
      </van-col>
      <van-col span="24" class="help_type_title"> {{ $t('column.frequent') }} </van-col>
      <van-col span="24" class="help_type_list">
        <van-collapse v-model="activeName" accordion>
          <van-collapse-item v-for="(t,j) in list" :key="j" :title="t.question" :name="j">{{ t.answer }}</van-collapse-item>
        </van-collapse>
      </van-col>
    </van-col>
    <van-col span="24" class="help_bottom">
      <van-col span="10" offset="1">
        <van-button round block color="#FFEAFE" class="help_bottom_color" @click="onClickButton('feedback_log')">{{ $t('title.my_feedback') }}</van-button>
      </van-col>
      <van-col span="10" offset="2">
        <van-button round block color="#FF61F5" @click="onClickButton('feedback')">{{ $t('column.message_feedback') }}</van-button>
      </van-col>
    </van-col>
  </div>
</template>

<script>
import Toast from 'vant/lib/toast'
import axios from "axios";
export default {
  data() {
    return {
      help_type: [],
      type_i: 0,
      list: [],
      activeName: undefined,
    }
  },
  created() {
    this.get_help_type()
  },
  methods: {
    get_help_type(){
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=user_h5&act=help",{ params:{ uid: uid, token: token }}).then(res =>{
        console.log(res.data)
        if(res.data.status===1){
          this.help_type = res.data.data
          if(this.help_type.length){
            this.get_help_list()
          }
        }else{
          Toast(res.data.error)
        }
      })
    },
    get_help_list(){
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=user_h5&act=help_list",{
        params:{
          uid: uid,
          token: token,
          title: this.help_type[this.type_i].title
        }}).then(res =>{
        console.log(res.data)
        if(res.data.status===1){
          this.list = res.data.data
        }else{
          Toast(res.data.error)
        }
      })
    },
    help_type_btn(i) {
      this.type_i= i
      this.get_help_list()
    },
    onClickButton(name) {
      const token = this.$route.query.token
      const uid = this.$route.query.uid
      this.$router.push({
        path: "/" + name,
        query:{ token: token, uid: uid }
      })
    },
    onClickLeft() {
      // 拦截关闭h5
      window.location.href="bogolive://exit"
    }
  }
}
</script>
<style scoped></style>


// WEBPACK FOOTER //
// src/components/help.vue